import { useState } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import axiosInstance from '../axiosConfig';
import './Checkout.css';
import Tiger from '../Assets/Images/tiger.gif';

const stripePromise = loadStripe('pk_live_51Qm0eHI8JCfI67oE7e3bqBczfL2J9baolWACViRaig56iiut9p31IN5OJS0mwTe6bLJdsTmZuFpiJ7U7EJpTR3uO00CR2qge06');

const Checkout = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [expandedBenefit, setExpandedBenefit] = useState(null);

  // Always use annual billing in the backend
  const billingCycle = 'annual';

  const handleCheckout = async () => {
    setLoading(true);
    setError('');

    try {
      // Send the billing cycle preference to the backend
      const response = await axiosInstance.post(
        '/create-checkout-session/',
        { billing_cycle: billingCycle },  // Pass the billing cycle preference
        {
          headers: {
            'Authorization': `Bearer ${localStorage.getItem('access_token')}`,
            'Content-Type': 'application/json',
          },
        }
      );

      console.log('Checkout session created:', response.data);

      const stripe = await stripePromise;
      if (!stripe) {
        throw new Error('Stripe failed to initialize');
      }

      const { error } = await stripe.redirectToCheckout({
        sessionId: response.data.id
      });

      if (error) {
        setError(error.message);
      }
    } catch (error) {
      console.error('Checkout error:', error);
      setError(
        error.response?.data?.error ||
        'Error processing payment. Please try again.'
      );
    } finally {
      setLoading(false);
    }
  };

  // Toggle expanded benefit details
  const toggleBenefitDetails = (index) => {
    // If clicking on the currently expanded benefit, don't collapse it
    // Only expand a different benefit or keep the current one expanded
    if (expandedBenefit !== index) {
      setExpandedBenefit(index);
    }
  };

  const benefits = [
    {
      title: "Information on 2,500+ Private Clubs",
      description: "Comprehensive database with details on initiation fees, dues, renovations, and other critical factors for private country clubs across the US.",
      icon: "📈"
    },
    {
      title: "Monday Play Program (Coming Soon)",
      description: "Exclusive opportunities to play at partner clubs on Mondays, letting you experience clubs before committing to membership.",
      icon: "🏌️"
    },
    {
      title: "20%+ Retail Discounts",
      description: "Substantial savings through exclusive member discounts at premier golf retailers, equipment manufacturers, and specialty accessory providers.",
      icon: "💰"
    },
    {
      title: "Community Access",
      description: "Connect with like-minded individuals through forums, message boards, and networking features.",
      icon: "👥"
    },
    {
      title: "Rewards System",
      description: "Earn points for contributing club updates and information, with quarterly prizes for top contributors.",
      icon: "🎁"
    }
  ];

  return (
      <div className="checkout-container">
        <div className="subscription-header">
          <h2 className="plan-title">Private Clubs. Public Knowledge.</h2>
          <p className="plan-subtitle">You're almost there. </p>

          <div className="plan-price">
            $20 <small>/year</small>
          </div>
        </div>
        <button
            onClick={handleCheckout}
            disabled={loading}
            className="checkout-button"
        >
          {loading ? (
              <span className="loading-indicator">
            <div className="loading-content">
              <img
                  src={Tiger}
                  alt="Loading..."
                  className="loading-gif"
              />
              <div>Processing...</div>
            </div>
          </span>
          ) : (
              'Become Member'
          )}
        </button>
        <div className="value-proposition">
          <h3 className="benefits-title">Exclusive Member Benefits</h3>
          <div className="benefits-container">
            {benefits.map((benefit, index) => (
                <div
                    key={index}
                    className={`benefit-card ${expandedBenefit === index ? 'expanded' : ''}`}
                    onClick={() => toggleBenefitDetails(index)}
                >
                  <div className="benefit-header">
                    <span className="benefit-icon">{benefit.icon}</span>
                    <h4 className="benefit-title">{benefit.title}</h4>
                    <span className="expand-icon">+</span>
                  </div>
                  <div className="benefit-details">
                    <p>{benefit.description}</p>
                  </div>
                </div>
            ))}
          </div>
        </div>

        <div className="plan-features">
          <h3 className="included-title">User-First Experience:</h3>
          <ul className="feature-list">
            <li className="feature-item">Zero advertisements</li>
            <li className="feature-item">Cancel anytime</li>
          </ul>
        </div>

        {error && (
            <div className="error-message">
              {error}
            </div>
        )}

      </div>
  );
};

export default Checkout;